import { useEffect, useState } from "react";

const Clock = (props) => {

    const { setCurrentDateTime } = props;
    const [dateTime, setDateTime] = useState('');

    useEffect(() => {
        function startTime() {
            const today = new Date();
            let date = today.getDate();
            let month = today.getUTCMonth();
            let year = today.getFullYear();
            let h = today.getHours();
            let m = today.getMinutes();           
            m = checkNumber(m);            
            month = checkNumber(month);
            let dateTime = date + "/" + month + "/" + year + " às " + h + ":" + m;
            if(setCurrentDateTime) {
                setCurrentDateTime(h + ":" + m);
            }
            setDateTime(dateTime);
            setTimeout(startTime, 1000);
        }
    
        function checkNumber(i) {
            if (i < 10) { i = "0" + i };  // add zero in front of numbers < 10
            return i;
        }  
        
        startTime();
    }, []);

    return (
        <>
            {dateTime}
        </>
    );
}

export default Clock;